import React from "react";
import ReactDOM from "react-dom";

import "./index.css";

import pic1 from "./images/color-switch.jpg";
import pic2 from "./images/rummy.png";
import pic3 from "./images/motions.png";
import pic4 from "./images/vending.png";
import pic5 from "./images/terminal.jpg";
import pic6 from "./images/evildevil.png";
import pic7 from "./images/movenlearn.png";
import pic8 from "./images/ourplanet.jpg";
import pic9 from "./images/usedcar.jpg";
import pic10 from "./images/electro.jpg";
import pic11 from "./images/netflix_logo.png";
import pic12 from "./images/deepfake.jpg";

const Project = () => {
  return (
    <>
      <section class="projects" id="projects">
        <div class="max-width">
          <h2 class="title">My Projects</h2>
          <div class="carousel owl-carousel">

          <a href="https://github.com/SakshatMali/Emotional-Taking-Faces.git" target='_blank'>
              <div class="card">
                <div class="box">
                  <img src={pic12} alt="" />
                  <div class="text">Emotional Talking Faces: Research Paper | Deepfake</div>
                  <p>
                    Published a Research Paper in ACM MM Asia 2022 (Tokyo, Japan). Created a Website for its Demo.
                  </p>
                </div>
              </div>
            </a>
  
            <a href="https://github.com/EtashTyagi/fcs_ecommerce.git" target='_blank'>
              <div class="card">
                <div class="box">
                  <img src={pic10} alt="" />
                  <div class="text">ElectroVerse: E-Commerce Website</div>
                  <p>
                    Fully functional secure e-commerce website built by using Django & Hosted on College Intra-Net
                  </p>
                </div>
              </div>
            </a>

            <a href="https://github.com/ddhroov10/django_final_netflix.git" target='_blank'>
              <div class="card">
                <div class="box">
                  <img src={pic11} alt="" />
                  <div class="text">Demo Netflix Website</div>
                  <p>
                    Fully functional, secure, netflix website built by using Django & Hosted on Azure Cloud
                  </p>
                </div>
              </div>
            </a>

            <a href="https://github.com/AnmolJindal2019/ML-Project--Used-cars-Price-Prediction.git" target='_blank'>
              <div class="card">
                <div class="box">
                  <img src={pic9} alt="" />
                  <div class="text">ML Project Used Car Price Prediction</div>
                  <p>
                    Built a Machine Learning Model to predict prices of used Cars
                  </p>
                </div>
              </div>
            </a>

            <a href="https://sites.google.com/iiitd.ac.in/des205-t13-pronoobs/home" target='_blank'>
              <div class="card">
                <div class="box">
                  <img src={pic7} alt="" />
                  <div class="text">MoveNLearn VR Game</div>
                  <p>
                    3D VR Learning Interactive Game Built in Unity 3D for Kids
                  </p>
                </div>
              </div>
            </a>

            <a href="https://github.com/SakshatMali/OurPlanet_AR_App" target='_blank'>
              <div class="card">
                <div class="box">
                  <img src={pic8} alt="" />
                  <div class="text">Our Planet AR Educational Game</div>
                  <p>
                    3D Learning Android Application Built in Unity 3D by using AR Core and Blender
                  </p>
                </div>
              </div>
            </a>

            <a href="https://github.com/SakshatMali/evilDevil.github.io" target='_blank'>
              <div class="card">
                <div class="box">
                  <img src={pic6} alt="" />
                  <div class="text">Evil Devil Game</div>
                  <p>
                    2D Game Built in JavaScript by using Phaser.js Library
                  </p>
                </div>
              </div>
            </a>

            <a href="https://github.com/SakshatMali/ColorSwitchGame" target='_blank'>
              <div class="card">
                <div class="box">
                  <img src={pic1} alt="" />
                  <div class="text">Color Switch Game</div>
                  <p>
                    Built in JavaFX and Designed using FXML
                  </p>
                </div>
              </div>
            </a>

            <a href="https://github.com/SakshatMali/Rummy-Game" target='_blank'>
              <div class="card">
                <div class="box">
                  <img src={pic2} alt="" />
                  <div class="text">Rummy Game</div>
                  <p>
                    Built in Python by using PyGame Library
                  </p>
                </div>
              </div>
            </a>

            <a href="https://github.com/SakshatMali/MotionStrikerGame" target='_blank'>
              <div class="card">
                <div class="box">
                  <img src={pic3} alt="" />
                  <div class="text">Motion Striker Game</div>
                  <p>
                    Built by using Arduino, Designed by using Processing.js and
                    Striker is controlled using Ultrasonic Sensor
                  </p>
                </div>
              </div>
            </a>

            <a href="https://github.com/SakshatMali/Source-Code-PIS-Major-Project" target='_blank'>
              <div class="card">
                <div class="box">
                  <img src={pic4} alt="" />
                  <div class="text">Gift Vending Machine</div>
                  <p>
                    Built by using Arduino, give Gifts when plastic is given to
                    the Vending Machine
                  </p>
                </div>
              </div>
            </a>
            
            <a href="https://github.com/SakshatMali/BasicLinuxTerminal" target='_blank'>
              <div class="card">
                <div class="box">
                  <img src={pic5} alt="" />
                  <div class="text">Linux Terminal</div>
                  <p>
                    Built in C Language, can execute most of the Linux Shell Commands
                  </p>
                </div>
              </div>
            </a>

          </div>
        </div>
      </section>
    </>
  );
};

export default Project;
